import { createIcon } from '@chakra-ui/react';

export const Copy = createIcon({
  displayName: 'Copy',
  viewBox: '0 0 64 64',
  path: (
    <path
      d="M62,9.56,54.41,2a5.09,5.09,0,0,0-7.2,0L30.88,18.33a5.11,5.11,0,0,0,0,7.2l2.74,2.73-5.36,5.36L25.55,30.9a5.09,5.09,0,0,0-7.2,0L2,47.23a5.1,5.1,0,0,0,0,7.21L9.59,62a5.09,5.09,0,0,0,7.2,0L33.12,45.67a5.11,5.11,0,0,0,0-7.2l-2.75-2.75,5.35-5.35,2.73,2.73a5.09,5.09,0,0,0,7.2,0L62,16.77A5.1,5.1,0,0,0,62,9.56Zm-31,31a2.11,2.11,0,0,1,0,3L14.68,59.9a2.15,2.15,0,0,1-3,0L4.12,52.33a2.12,2.12,0,0,1,0-3L20.45,33a2.11,2.11,0,0,1,3,0l2.72,2.71-5.94,5.94a1.49,1.49,0,1,0,2.1,2.11l5.94-5.94ZM59.88,14.66,43.55,31a2.16,2.16,0,0,1-3,0l-2.73-2.73,5.94-6a1.48,1.48,0,0,0-2.1-2.1l-6,5.95L33,23.42a2.11,2.11,0,0,1,0-3L49.32,4.1a2.11,2.11,0,0,1,3,0l7.57,7.57A2.12,2.12,0,0,1,59.88,14.66Z"
      fill="currentColor"
    />
  ),
});
